'use strict'

const state = {
  // name of default route
  defaultPathName: 'responses'
}

export default {
  namespaced: true,
  state
}
